import React from "react";
import ExpansionPanel from "./ExpansionPanel";
import ExpansionPanelSummary from "./ExpansionPanelSummary";
import ExpansionPanelDetails from "./ExpansionPanelDetails";
import { HtmlReactParser } from "@kaltura/mediaspace-shared-utils";
import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export interface FaqQuestion {
    questionText: string;
    answerHtml: string;
}

export interface FaqSectionItem {
    titleText: string;
    questions: FaqQuestion[];
}

export interface FaqSectionProps {
    sections: FaqSectionItem[];
}

const StyledFaq = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
}));

const StyledGridSection = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(6),
}));

/**
 * Component to render a FaqSection inside event platform filters
 */
const FaqSection = ({ sections = [] }: FaqSectionProps) => {
    return (
        <StyledFaq className="kms-ds-help-page-faq">
            {sections.map(({ titleText, questions }, sectionIndex) => {
                return (
                    <StyledGridSection key={titleText} className="kms-ds-help-page-faq-section">
                        <Typography component={"h2"} variant={"h3"}>
                            {titleText}
                        </Typography>
                        {questions.map(({ questionText, answerHtml }, index) => {
                            return (
                                <ExpansionPanel key={questionText} faqId={`${sectionIndex}-${index}`}>
                                    <ExpansionPanelSummary>{questionText}</ExpansionPanelSummary>
                                    <ExpansionPanelDetails>{HtmlReactParser(answerHtml)}</ExpansionPanelDetails>
                                </ExpansionPanel>
                            );
                        })}
                    </StyledGridSection>
                );
            })}
        </StyledFaq>
    );
};

export default FaqSection;
